@use "../../../../styles/util/shadow.scss" as shadow;

:host {
    position: absolute;
    display: block;
    touch-action: none; // evita el scroll del navegador al arrastrar
    user-select: none;
    cursor: grab;
    transition: transform 0.1s ease-out;
    will-change: transform;
    width: 1px;
    height: 1px;
}

:host([active]) {
    cursor: grabbing;
    transition: none;

    // .bubble-inner {
    //     // box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8), 0 4px 12px rgba(0, 0, 0, 0.15);
    // }
}

:host(.snapping) {
    transition: transform 0.4s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.bubble-inner {
    --size: 60px;
    --backgroundColor: #0084ff;
    --x: 0px;
    --y: 0px;
    --scale: 0;
    --transition: none; // transform 0.1s ease-out;
    --transform: none; // translate3d(var(--x), var(--y), 0) scale(var(--scale));
    width: var(--size);
    height: var(--size);
    border-radius: 50%;
    background: var(--backgroundColor);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    transition: var(--transition);
    transform: var(--transform);

    @include shadow.shadow-floating-small;
}